import {AsyncPipe} from "@angular/common";
import {Component, EventEmitter, Inject, InjectionToken, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ClientService} from "@app/admin/client.service";
import {User, UserService} from "@shared/user.service";
import {Observable, switchMap} from "rxjs";
import {tap} from "rxjs/operators";


export const MENTION_QUERY = new InjectionToken<string>('MENTION_QUERY');


@Component({
  selector: 'frog-mention-overlay',
    imports: [
        AsyncPipe
    ],
  templateUrl: './mention-overlay.component.html',
  styleUrl: './mention-overlay.component.scss'
})
export class MentionOverlayComponent implements OnInit, OnChanges {
    @Output() select = new EventEmitter<User>();

    public users$: Observable<User[]>;

    public users: User[];
    public index: number;
    private _allUsers: User[];

    constructor(
        private clientService: ClientService,
        private userService: UserService,
        @Inject(MENTION_QUERY) private query: string,
    ) {
        this.index = -1;
        this._allUsers = [];
        this.users = [];
    }

    ngOnInit() {
        this.users$ = this.clientService.get()
            .pipe(
                switchMap(() => this.userService.users),
                tap(users => {
                    this._allUsers = users;
                    this.users = this.filter(this.query);
                    if (this.users.length > 0) {
                        this.index = 0;
                    }
                })
            );
    }

    ngOnChanges(changes: SimpleChanges) {
        this.filter(this.query);
    }

    public filterUsers(query: string): void {
        this.users = this.filter(query);
    }

    public selectOffset(offset: number) {
        this.index += offset;
        if (this.index >= this.users.length) {
            this.index = 0;
        }
        else if (this.index < 0) {
            this.index = this.users.length - 1;
        }
    }

    public triggerSelect() {
        this.select.emit(this.users[this.index]);
    }

    filter(value: string): User[] {
        const query = value.toLowerCase();
        return this._allUsers.filter(user => `${user.name}${user.email}`.toLowerCase().includes(query));
    }
}
